import { combineLatest } from 'rxjs';
import { SectionId } from '../configs/section-id-enum';
import { SagittaScoreArea } from './sagitta-score-area';
import { SagittaScoreEvaluation } from './sagitta-score-evaluation';

export class SagittaScore {
  overallEsgScore: number | '';
  constructor(
    public overallScore: number,
    overallEsgScore: number | null,
    public overallEvaluation: SagittaScoreEvaluation,
    public areas: SagittaScoreArea[]
  ) {
    this.overallEsgScore =
      overallEsgScore !== null && overallEsgScore !== undefined
        ? overallEsgScore
        : '';

    let areaCounter$ = this.areas.map((area) => area.counter$);
    combineLatest(areaCounter$).subscribe((counters) => {
      this.updateScoreCounters(counters);
    });
  }

  static subscribeToFormFieldValueChanges(areas: SagittaScoreArea[]) {
    let allElements = areas
      .map((area) => area.sections)
      .flat()
      .map((section) => section.rows)
      .flat()
      .map((row) => row.elements)
      .flat();

    let identificazioneDelSettoreField = allElements.find(
      (el) => el.id === SectionId.identificazioneDelSettore
    );
    allElements.forEach((el) => {
      el.init(identificazioneDelSettoreField?.field.controlRef?.valueChanges);
    });
  }

  private updateScoreCounters(counters: number[]) {
    this.overallScore = this.calcScoreComplessivo(counters);
    this.overallEvaluation = this.calcScoreEvaluation();
    this.updateEsg();
  }

  private calcScoreComplessivo(counters: number[]) {
    let scoreComplessivo = counters?.reduce((el, acc) => el + acc) || 0;
    return scoreComplessivo;
  }

  private updateEsg() {
    let esg = this.areas.find((area) => area.area === 'E')?.total;
    this.overallEsgScore = this.calcEsg(esg || 0, this.overallScore);
  }

  private calcEsg(esgNotching: number, scoreComplessivo: number) {
    return esgNotching + scoreComplessivo;
  }

  private calcScoreEvaluation(): SagittaScoreEvaluation {
    let scoreEvaluation: SagittaScoreEvaluation;
    if (this.areas[0].area === 'X') {
      for (let section of this.areas[0].sections) {
        for (let el of section.rows[0].elements) {
          if (el.field.formControlName === '23') {
            if (el.field.controlRef?.value?.view !== 'nessuno dei precedenti') {
              scoreEvaluation = 'LOW';
              return scoreEvaluation;
            }
          }
        }
      }

      if (this.overallScore > 300) {
        scoreEvaluation = 'HIGH';
      } else {
        scoreEvaluation = 'AVERAGE';
      }
      return scoreEvaluation;
    }
    if (this.overallScore > 75) {
      scoreEvaluation = 'HIGH';
    } else if (this.overallScore <= 75 && this.overallScore > 55) {
      scoreEvaluation = 'ABOVE-AVERAGE';
    } else if (this.overallScore <= 55 && this.overallScore > 35) {
      scoreEvaluation = 'AVERAGE';
    } else if (this.overallScore <= 35 && this.overallScore > 15) {
      scoreEvaluation = 'BELOW-AVERAGE';
    } else {
      scoreEvaluation = 'LOW';
    }
    return scoreEvaluation;
  }
}
